// extracted by mini-css-extract-plugin
export default {"Container":"TrendingChannels_Container__1M4LU"};